const chat = require('../../../../../components/chat/chat')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./provider-fullcont-handler')

export function start(detail) {
    if (obj[detail.act]) {
        obj[detail.act].start(detail)
    }
}

const obj = {
    load:       { start: (detail) => { load(detail)         } },
    submit:     { start: (detail) => { submit(detail)       } },
    typing:     { start: (detail) => { typing(detail)       } },
    beforeChat: { start: (detail) => { beforeChat(detail)   } },
}

function load(detail) {

    const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
    const recordId = fullcontActivo.getAttribute('data-dbid')

    if (recordId) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "provider",
                "entity": "provider",
                "question": detail.question ?? "",
                "recordId": recordId,
                "ev": detail.ev
            }
        )

        const msj = handler.getChatsFc();
        chat.start({
            "dest": "chat",
            "act": "load",
            "chats": msj
        })
    }

}

function beforeChat(detail) {

    const htmlFc = handler.getDataFc()

    const dataToSend = handler.getValuesForChat(detail, htmlFc)
    if (dataToSend) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "providerBefore",
                "entity": "item",
                "data": dataToSend,
                "question": detail.question ?? "",
                "ev": detail.ev
            }
        )
    }
}

function typing(detail) {
    chatHandler.typing(detail)
}